export function doDesignerAction(designer, action) {
  action.designer = designer;
  action.execute();
  const tab = designer.getActiveTab();
  if (tab.undoableActions == null)
    tab.undoableActions = [];
  tab.undoableActions.push(action);
  tab.redoableActions = [];
  if (designer._notifyAction != null)
    designer._notifyAction();
}

export function undoDesignerAction(designer) {
  const tab = designer.getActiveTab();
  if (tab.undoableActions != null && tab.undoableActions.length > 0) {
    const action = tab.undoableActions.pop();
    action.undo();
    if (tab.redoableActions == null)
      tab.redoableActions = [];
    tab.redoableActions.push(action);
    if (designer._notifyAction != null)
      designer._notifyAction();
  }
}

export function redoDesignerAction(designer) {
  const tab = designer.getActiveTab();
  if (tab.redoableActions != null && tab.redoableActions.length > 0) {
    const action = tab.redoableActions.pop();
    action.execute();
    if (tab.undoableActions == null)
      tab.undoableActions = [];
    tab.undoableActions.push(action);
    if (designer._notifyAction != null)
      designer._notifyAction();
  }
}

export function getDesignerUndoAction(designer) {
  const tab = designer.getActiveTab();
  if (tab.undoableActions != null && tab.undoableActions.length > 0)
    return tab.undoableActions[tab.undoableActions.length - 1];
  return null;
}

export function getDesignerRedoAction(designer) {
  const tab = designer.getActiveTab();
  if (tab.redoableActions != null && tab.redoableActions.length > 0)
    return tab.redoableActions[tab.redoableActions.length - 1];
  return null;
}
